import React from 'react'

const Bullet = (props) => {
    return (
        <span
            style={{
                display: 'inline-block',
                position: 'relative',
                top: '-0.1em',
                verticalAlign: 'middle',
                height: '.9em',
                marginRight: '10px',
                borderLeft: '5px solid ' + props.colore
            }}
        />
    )
}

export default Bullet


// WEBPACK FOOTER //
// ./src/components/sito/temi/layoutorizzontale/utilities/bullet/index.js